<!-- eslint-disable no-unused-vars -->
<!-- eslint-disable no-unused-vars -->
<template>
  <div class="container">
    <component :is="viewComponent"
               v-if="playerReady"
               :key="viewComponentKey"/>
    <component :is="errorComponent"
               v-if="!playerReady"
               :msg="errorMessage"/>
  </div>
</template>

<script>
//import libConst from "../lib/libConst.js";
import functions from "../lib/functions.js";
import VideoJS from "./VideoJS.vue";
import IWEmpty from "./IWEmpty.vue";
import IWError from "./IWError.vue";
import IWImage from "./IWImage.vue";
import {v4 as uuidv4, v5 as uuidv5} from 'uuid';
import UaParser from 'ua-parser-js';
import {bootstrap, setOptions} from "vue-gtag";

const userAgentData = new UaParser(navigator.userAgentData ?? navigator.userAgent).getResult();
let info = '';
if (userAgentData) {
  info = `&browser=${userAgentData.browser?.name}&platform=${userAgentData.os?.name}`;
  const mobile = userAgentData.device?.type ?? false;
  info += `&mobile=${mobile}`;
}

export default {
  name: "IWPlayer",
  props: {
    uniqueID: String,
  },
  components: {
    VideoJS,
    IWEmpty,
    IWError,
    IWImage,
  },
  data: function () {
    return {
      errorMessage: "",
      errorMessageType: null,
      playerReady: false,
      updatePlayerJsonInterval: null,
      activeEventStatusChecked: false,
      viewComponentKey: 0,
      checkCuepointsInterval: null,
      pingIwcacheInterval: null,
      waitSetContentPath: null
    };
  },
  computed: {
    viewComponent: function () {
      let comp = undefined;
      switch (this.$store.getters.getCuePoint.layout_mode) {
        case "videoslide":
        case "video":
        case "vod":
          comp = VideoJS;
          break;
        case "image":
          comp = IWImage;
          break;
        default:
          comp = IWEmpty;
          break;
      }
      return comp;
    },
    errorComponent: function () {
      return IWError;
    },
  },
  created() {
    if (window.location !== window.parent.location && window.parent[0]?.name === 'fidogroupIframe') { //iframe
      window.addEventListener("message", this.parent_msg_event_incoming, false);
    } else {
      if (this.$store.getters.getUniqueIDType != 'vod') {
        this.$store.commit(
          "setContentBasePath",
          process.env.VUE_APP_IWCAST_CONTENT_BASEURL
        );
      } else {
        let VUE_APP_IWCAST_CONTENT_BASEURL_vod_arr = process.env.VUE_APP_IWCAST_CONTENT_BASEURL.split('/');
        VUE_APP_IWCAST_CONTENT_BASEURL_vod_arr.pop();
        let VUE_APP_IWCAST_CONTENT_BASEURL_vod = VUE_APP_IWCAST_CONTENT_BASEURL_vod_arr.join('/');
        VUE_APP_IWCAST_CONTENT_BASEURL_vod += '/vods';
        this.$store.commit(
          "setContentBasePath",
          VUE_APP_IWCAST_CONTENT_BASEURL_vod
        );
      }
      this.created(false);
    }
  },
  beforeMount() {
    if (window.location === window.parent.location || window.parent[0]?.name !== 'fidogroupIframe') { //STANDALONE
      this.beforeMount();
    }
  },
  mounted() {
  },
  updated() {
  },
  beforeUnmount() {
    window.removeEventListener(
      "message",
      this.parent_msg_event_incoming,
      false
    );
  },
  beforeDestroy() {
    if (this.checkCuepointsInterval) {
      clearInterval(this.checkCuepointsInterval);
    }
    if (this.pingIwcacheInterval) {
      clearInterval(this.pingIwcacheInterval);
    }
  },
  methods: {

    created: async function (callBeforeMount) {

      // let _hostname = window.location.hostname;
      // _hostname = "iwcache-staging.it";
      if (window.location.hostname.includes(process.env.VUE_APP_IWCACHE_DOMAIN_KEY)) {
        this.$store.commit("setIwcacheActive", true);
        let _protocol = window.location.protocol;
        let _host = window.location.host;
        let _content_base_url =
          this.$store.getters.getUniqueIDType != 'vod'
            ?
            _protocol + "//" + _host + "/content/events"
            :
            _protocol + "//" + _host + "/content/vods"
        ;

        this.$store.commit(
          "setContentBasePath",
          _content_base_url
        );
      } else {
        this.$store.commit("setIwcacheActive", false);
      }

      await this.updatePlayerJson();


      if (process.env.VUE_APP_REFRESH_PLAYERJSON_INTERVAL > 0) {
        this.updatePlayerJsonInterval = window.setInterval(
          async () => {
            if (this.$store.getters.getActive) {
              if (this.activeEventStatusChecked == true) {
                clearInterval(this.updatePlayerJsonInterval);
                /*
                 this.updateVideoJSOptions();
                 if (!this.playerReady) {
                 this.playerReady = true;
                 }
                 */
                return;
              } else {
                this.activeEventStatusChecked = true;
              }
            }

            await this.updatePlayerJson();
            if (!this.playerReady) {
              this.playerReady = true;
            }
            if (this.activeEventStatusChecked == true) {
              //this.viewComponentKey++;
            }
          },
          process.env.VUE_APP_REFRESH_PLAYERJSON_INTERVAL
        );
      }
      if (callBeforeMount) {
        this.beforeMount();
      }
    },
    beforeMount: function () {
      if (this.$store.getters.getUniqueIDType === 'vod') {
        //return;
      }
      this.$store.watch((state) => state.statusCuepoint,
        async (newStatusCuepoint) => {
          if (newStatusCuepoint != "no_status") {
            let url =
              this.$store.getters.getContentBasePath +
              "/" +
              this.$store.getters.getUniqueID +
              "/data/cuepoints/" +
              newStatusCuepoint +
              ".json";
            let response = await fetch(url);
            let dataCuepoint = await response.json();
            if (this.$store.getters.getStreamindex != null) {
              dataCuepoint.layout_mode = 'video';
              dataCuepoint.status = 'live';
            }
            this.$store.commit("setCuePoint", dataCuepoint);
            if (dataCuepoint.status === 'vod') {
              let vodCurOutput = this.$store.getters.getVodCurOutput;
              let vodCurOutputRecordingsFilename = vodCurOutput.substring(vodCurOutput.lastIndexOf('/') + 1);
              vodCurOutputRecordingsFilename = vodCurOutputRecordingsFilename.substring(0, vodCurOutputRecordingsFilename.lastIndexOf('.'));
              vodCurOutputRecordingsFilename += ".json";
              let url =
                this.$store.getters.getContentBasePath +
                "/" +
                this.$store.getters.getUniqueID +
                "/data/recordings/" +
                vodCurOutputRecordingsFilename;
              try {
                let response = await fetch(url);
                if (response.ok) {
                  let cuepoints = await response.json();
                  this.$store.commit("setCuePoints", cuepoints);
                } else {
                  this.$store.commit("setCuePoints", null);
                }
              } catch (err) {
                this.$store.commit("setCuePoints", null);
              }
            } else {
              this.$store.commit("setCuePoints", null);
            }
          } else {
            let data = JSON.parse(process.env.VUE_APP_CUEPOINT_NO_STATUS);
            this.$store.commit("setCuePoint", data);
          }
          this.updateVideoJSOptions();
          if (!this.playerReady) {
            this.playerReady = true;
          }

        }
      );
    },
    updatePlayerJson: async function () {
      // fetch player.json configuration
      var _url =
        this.$store.getters.getContentBasePath +
        "/" +
        this.$store.getters.getUniqueID +
        "/data/player.json?" +
        functions.noCache();
      fetch(_url)
        .then((response) => response.json())
        .then(async (data) => {
          this.$store.commit("setActive", data.active);
          this.$store.commit("setAuto_resize", data.auto_resize ?? false);

          if (!this.$store.getters.getDef_lang) {
            this.$store.commit("set_def_lang", data.cms_def_lang);
          }
          if (!this.$store.getters.getCur_lang) {
            this.$store.commit("set_cur_lang", data.cms_def_lang);
          }
          this.$store.commit("setStreamOutputs", data.outputs);
          this.$store.commit("setIwcache", {
            domain_name: data.domain_name,
            iwcache_network_id: data.iwcache_network_id,
            iwcache_network_only: data.iwcache_network_only
          });
          this.$store.commit("setVideoJSOptions_audio_only_mode", data.audio_only_mode);
          if (data.audio_only_mode) {
            this.$store.commit("setVideoJSOptions_nativeControlsForTouch", false);
          }
          if (data.poster) {
            const poster_url = this.$store.getters.getContentBasePath + '/' + this.$store.getters.getUniqueID + '/data/' + data.poster;
            this.$store.commit("setPoster", poster_url);
          }

          // if (window.location.host.includes(this.$store.getters.getIwcache.iwcache_network_id)) {
          //   this.$store.commit("setIwcacheActive", true);
          // } else {
          //   this.$store.commit("setIwcacheActive", false);
          // }

          this.$store.commit("setSkin", data.skin);

          await this.checkDelivery(data);

          if (this.$store.getters.getActive) {
            this.activeEventStatusChecked = true;
            /********** non metto in play l'output: aspetto di vedere se c'è un cuepoint e poi aggiorno videojs
             await this.updateVideoJSOptions();
             if (!this.playerReady) {
             this.playerReady = true;
             }
             *********/
            //this.viewComponentKey++;
          }

          return data;
        })
        .catch(() => {
          this.errorMessage = "Unable to fetch player configuration";
          this.errorMessageType = 'player.json.fetch.error';
          this.playerReady = false;
          return null;
        });
    },
    updateVideoJSOptions: function () {
      let newVideoJSOptions;
      if (this.$store.getters.getCuePoint.status == "live") {
        newVideoJSOptions = {
          autoplay: this.$store.getters.getPlayerParameters.autoplay,
          src: this.$store.getters.getStream.liveURL,
          loop: this.$store.getters.getPlayerParameters.loop,
        };
      } else if (this.$store.getters.getCuePoint.status == "override") {
        newVideoJSOptions = {
          autoplay: this.$store.getters.getPlayerParameters.autoplay,
          src: this.$store.getters.getStream.overrideURL,
          loop: this.$store.getters.getPlayerParameters.loop,
        };
      } else if (this.$store.getters.getCuePoint.status == "vod") {
        newVideoJSOptions = {
          autoplay: this.$store.getters.getPlayerParameters.autoplay,
          src: this.$store.getters.getVodCurOutput,
          loop: this.$store.getters.getPlayerParameters.loop,
        };
      }
      if (newVideoJSOptions?.src) {
        let src_extension = newVideoJSOptions.src.split('.').pop();
        if (src_extension == 'mp4') {
          newVideoJSOptions.type = 'video/mp4';
        } else {
          newVideoJSOptions.type = 'application/x-mpegURL';
        }
      }
      this.$store.commit("setVideoJSOptions", newVideoJSOptions);
    },
    checkDelivery: async function (playerData) {
      // first of all, check if we need to go to iwcache
      //this.$store.commit("setIwcache", {
      //  iwcache_network_id: playerData.iwcache_network_id,
      //});
      if (this.$store.getters.getIwcache.iwcache_network_id > 0) {
        if (this.$store.getters.getIwcacheActive) {
          // inside iwcache, fetch config info from the cacher itself
          fetch("/config?" + functions.noCache())
            //fetch("https://ntw1-gab.iwcache-staging.it/config?" + functions.noCache())
            .then((response) => response.json())
            .then((iwcacheData) => {
              try {
                if (!this.pingIwcacheInterval) {
                  let uuid;
                  uuid = localStorage.getItem('iwcast_' + this.$store.getters.getUniqueID)
                  if (uuid == null) {
                    const namespace = uuidv4(); //const namespace = '2b671a64-41d5-491e-99b0-da01ff1f3341';
                    uuid = uuidv5('iwmonUUID', namespace);
                  }
                  localStorage.setItem('iwcast_' + this.$store.getters.getUniqueID, uuid)
                  this.pingIwcache(uuid);
                }
              } catch (e) {
                console.log(e);
                this.errorMessageType = 'iwcache.ping.error';
              }
              if (iwcacheData.p2p == "1") {
                const p2pgroup = ((iwcacheData.p2pgroup && this.$store.getters.getIwcache.entrypoint_id) ? (iwcacheData.p2pgroup + "_" + this.$store.getters.getIwcache.entrypoint_id) : null)
                this.$store.commit("setP2PConfig", {
                  p2p: true,
                  p2ptech: iwcacheData.p2ptech,
                  p2pip: iwcacheData.myip,
                  p2pgroup,
                });
              }
              this.$store.commit("setRendition", iwcacheData.rendition);
              if (iwcacheData.rendition != 'master') {
                this.$store.commit("setStreamOutputs");
              }

              this.initPlayerData(playerData);
            })
            .catch((e) => {
              console.log(e);
              this.errorMessageType = 'iwcache.config.fetch.error';
              this.errorMessage =
                "Unable to fetch iWCache configuration";
              this.playerReady = false;
            });
        } else {
          // not yet in iwcache, fetch the group info to see where you are mapped
          let _url = process.env.VUE_APP_IWCAST_API_URL + "/iwcacheNetworks/info/" +
            this.$store.getters.getIwcache.iwcache_network_id +
            "?" +
            functions.noCache();
          fetch(_url)
            .then((response) => response.json())
            .then((iwcacheData) => {
              if (iwcacheData.success === true) {
                if (iwcacheData.host != "") {
                  // found a host, send to iwcache
                  window.location =
                    "https://" +
                    iwcacheData.host +
                    window.location.search;

                } else {
                  // host not found, keep him here
                  if (this.$store.getters.getIwcache.iwcache_network_only) {
                    this.errorMessage = 'Contents available only on the intranet network';
                    this.playerReady = false;
                  } else {
                    this.initPlayerData(playerData);
                  }
                }
              } else {
                if (this.$store.getters.getIwcache.iwcache_network_only) {
                  this.errorMessageType = 'iwcache.info.fetch.error';
                  if (iwcacheData.error?.message) {
                    this.errorMessage = iwcacheData.error?.message;
                    this.playerReady = false;
                  } else if (iwcacheData.error) {
                    this.errorMessage = iwcacheData.error;
                    this.playerReady = false;
                  } else {
                    this.errorMessage = iwcacheData;
                    this.playerReady = false;
                  }
                } else { //I'll continue as if nothing happened
                  //I clear the iwcache
                  this.$store.commit("setIwcache", {
                    domain_name: this.$store.getters.getIwcache.domain_name,
                    iwcache_network_id: 0,
                    iwcache_network_only: false
                  });
                  this.initPlayerData(playerData);
                }
              }
            })
            .catch(() => {
              this.errorMessageType = 'iwcache.info.fetch.error';
              this.errorMessage =
                "Unable to fetch Network configuration";
              this.playerReady = false;
            });
        }
      } else {
        this.initPlayerData(playerData);
      }
    },
    initPlayerData: async function (playerData) {
      // eslint-disable-next-line
      // set the parameters
      this.$store.commit("setTitle", playerData.title);
      this.$store.commit("setAnalytics", playerData.analytics);

      var paramsSearch = new URLSearchParams(window.location.search);
      let disable_check_cuepoints_url_param = paramsSearch.get("disable_check_cuepoints");
      if (!disable_check_cuepoints_url_param) {
        this.$store.commit("set_disable_check_cuepoints", playerData.disable_check_cuepoints);
      }

      let setPlayerParametersPars = {
        disableLegacyBrowsers: true,
        autoplay: playerData.autoplay,
        loop: playerData.loop,
        debug: true,
      };
      if (playerData.low_latency) {
        setPlayerParametersPars["lowLatency"] = playerData.low_latency;
      }
      this.$store.commit("setPlayerParameters", setPlayerParametersPars);

      if (this.$store.getters.getIwcacheActive && this.$store.getters.getStreamCurOutput) {
        if (process.env.VUE_APP_IWCAST_ENVIRONMENT == "staging") {
          this.$store.commit("setStream", {
            liveURL: this.$store.getters.getStreamCurOutput.replace(
              "https://iwcast-staging.akamaized.net/hls",
              "/hls"
            ),
            lowLatency:
            this.$store.getters.getPlayerParameters.lowLatency,
          });
        } else {
          if (this.$store.getters.getStreamCurOutput.includes('.akamaized.net/hls')) {
            this.$store.commit("setStream", {
              liveURL: this.$store.getters.getStreamCurOutput
                .replace("https://iw", "/hls")
                .replace(".akamaized.net/hls", ""),
              lowLatency:
              this.$store.getters.getPlayerParameters.lowLatency,
            });
          } else {
            //ATTENZIONE: i domini personalizzati funzionano solo su iw1 quando iwcache è attivo!!!!
            const streamCurOutput = this.$store.getters.getStreamCurOutput;
            const boundary = '/iw/hls';
            this.$store.commit("setStream", {
              liveURL: '/hls1' + streamCurOutput.substring(streamCurOutput.indexOf(boundary) + boundary.length),
              lowLatency: this.$store.getters.getPlayerParameters.lowLatency,
            });
          }
        }
      } else {
        this.$store.commit("setStream", {
          liveURL: this.$store.getters.getStreamCurOutput,
          overrideURL: playerData.output_override,
          lowLatency: this.$store.getters.getPlayerParameters.lowLatency,
        });
      }
      // init analytics
      let analyticsItemGoogle = this.$store.getters.getAnalyticsItemByKind("google")
      if (analyticsItemGoogle) {
        let setOptionsVal = {
          config: {
            id: analyticsItemGoogle.attributes.code,
            params: {
              send_page_view: true,
            },
          },
        };
        setOptions(setOptionsVal);

        bootstrap();
      }

      if (!this.$store.getters.get_disable_check_cuepoints) {
        if (!this.checkCuepointsInterval) {
          this.checkCuepointsInterval = window.setInterval(
            async () => {
              if (this.$store.getters.getCuePoints && this.$store.getters.getIsPlayerPlaying) {
                return;
              }
              if (
                process.env.VUE_APP_DISABLE_INSIDE_STREAM_CUEPOINTS === 'true'
                ||
                !(
                  (
                    this.$store.getters.getCuePoint.layout_mode == "video"
                    ||
                    this.$store.getters.getCuePoint.layout_mode == "videoslide"
                  )
                  &&
                  this.$store.getters.getCuePoint.status == "live"
                  &&
                  this.$store.getters.getIsPlayerPlaying
                )
              ) {
                await this.refreshStatus();
              }
            },
            process.env.VUE_APP_REFRESH_INTERVAL
          );
        }
      }

      if (!this.$store.getters.get_disable_check_cuepoints) {
        await this.refreshStatus();
      } else {
        let data = {
          "q": "no_status"
        };
        this.$store.commit("setStatusCuepoint", data.q);
      }
    },
    // refresh the player status
    refreshStatus: async function () {
      var fetch_url_status =
        this.$store.getters.getContentBasePath +
        "/" +
        this.$store.getters.getUniqueID +
        "/data/status.json?" +
        functions.noCache();
      let status_data;
      try {
        let fetch_resp = await fetch(
          fetch_url_status
        );
        if (fetch_resp.ok) {
          status_data = await fetch_resp.json();
        } else if (fetch_resp.status === 404) {
          /*data = {
           "q": "no_status"
           };*/
        } else {
          return;
        }
      } catch (err) {
        /*data = {
         "q": "no_status"
         };*/
      }
      if (status_data != null) {
        this.$store.commit("setStatusCuepoint", status_data.q);
      } else {
        if (this.$store.getters.getStatusCuepoint == 0) { //all'inizio setto no status, poi devo rimanere su quello attuale
          this.$store.commit("setStatusCuepoint", "no_status");
        }
      }
    },
    parent_msg_event_incoming(event) {
      if (event.data.type == "changeLang") {
        let newLang = event.data.content.lang;
        if (this.$store.getters.getCur_lang != newLang) {
          this.$store.commit("set_cur_lang", newLang);
          this.$store.commit("setStreamOutputs");
          this.$store.commit("setVodOutputs");
          this.$store.commit("setStream", {
            liveURL: this.$store.getters.getStreamCurOutput,
            overrideURL: this.$store.getters.getStream.overrideURL,
            lowLatency: this.$store.getters.getStream.lowLatency,
          });
          this.updateVideoJSOptions();
        }
      } else if (event.data.type == "setContentPath") {
        this.$store.commit(
          "setContentBasePath",
          this.$store.getters.getUniqueIDType != 'vod'
            ?
            `${event.data?.content?.url}/events`
            :
            `${event.data?.content?.url}/vods`
        );
        this.created(true);
        clearTimeout(this.waitSetContentPath);
      }
    },
    pingIwcache: function (uuid) {
      clearInterval(this.pingIwcacheInterval);
      const _url = `${window.location.protocol}//${window.location.host}/api/v1/iwcache/player/ping?id=${uuid}${info}&${functions.noCache()}`;
      fetch(_url)
        .catch(() => {
          this.errorMessageType = 'iwcache.ping.fetch.error';
          this.errorMessage =
            "Unable to ping cacher";
          }
        ).finally(() => {
        this.pingIwcacheInterval = window.setTimeout(
          () => {
            this.pingIwcache(uuid)
          },
          process.env.VUE_APP_REFRESH_CACHER
        );
      })
    }
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  background-color: transparent;
}
</style>
